import { parseAsciiMap, type TileMap } from '../tilemap';

/**
 * Valle delle Faglie — la regione iniziale del gioco.
 *
 * Legenda: . erba  , cespugli (incontri)  # sentiero  ~ acqua  s sabbia
 *          T albero  O roccia  f arbusti  A anomalia
 *          H stazione di risonanza (porta)  h muro della stazione
 *
 * In alto a sinistra l'avamposto dei Custodi (casa con porta H);
 * al centro il Lago Specchio; in basso a destra il Cratere della Faglia,
 * dove si incontrano i Lumini più rari.
 */

const ROWS: string[] = [
  'TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT',
  'T.............f................f......TT',
  'T...........O..........................T',
  'T..f..........hHh......,,,,........f...T',
  'T..............#.......,,,,............T',
  'T...,,,........#.......,,,,...TT.......T',
  'T..,,,,.......################..TT.....T',
  'T..,,,,....................#...........T',
  'T..,,,,.....TT.............#......,,...T',
  'T...........TT.............#.....,,,,..T',
  'T..........ssssssss........#.....,,,,..T',
  'T.....f....s~~~~~~s........#.....,,,,..T',
  'T..........s~~~~~~s........#......,,...T',
  'T...,,,....s~~~~~~s........#...........T',
  'T..,,,,,...s~~~~~~s........#......f....T',
  'T..,,,,,...s~~~~~~s........#...........T',
  'T..,,,,,...ssssssss........#...........T',
  'T...,,,....................#...........T',
  'T............f.............#....OOOOOOOT',
  'T..........................#....OAAAAAOT',
  'T..........................######AAAAAOT',
  'T..,,,,.........................OAAAAAOT',
  'T..,,,,.......f.................OOOOOOOT',
  'T..,,,,...........,,,..................T',
  'T............TT...,,,.........f........T',
  'T............TT...,,,..................T',
  'T...f.......................TT.........T',
  'T...........f...............TT.....f...T',
  'T......................................T',
  'TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT',
];

export interface EncounterEntry {
  speciesId: string;
  weight: number;
  minLevel: number;
  maxLevel: number;
}

export interface MapDef {
  id: string;
  name: string;
  map: TileMap;
  /** Punto di spawn del giocatore, in pixel. */
  spawn: { x: number; y: number };
  /** Prop scenografici posizionati a mano (id del prop in assets/props). */
  landmarks?: { prop: string; tx: number; ty: number }[];
  encounters: {
    tallGrass: EncounterEntry[];
    anomaly: EncounterEntry[];
  };
  /** Probabilità di incontro per passo su tile di erba alta / anomalia. */
  encounterRate: { tallGrass: number; anomaly: number };
}

export function createValleDelleFaglie(): MapDef {
  return {
    id: 'valle-delle-faglie',
    name: 'Valle delle Faglie',
    map: parseAsciiMap(ROWS.join('\n')),
    spawn: { x: 14.5 * 32, y: 5 * 32 },
    landmarks: [
      // la Torre di Pietra Magica domina il Cratere della Faglia
      { prop: 'magic-tower', tx: 35, ty: 18 },
      // il pozzo dell'avamposto dei Custodi
      { prop: 'well', tx: 12, ty: 2 },
    ],
    encounters: {
      tallGrass: [
        { speciesId: 'voltilla', weight: 30, minLevel: 2, maxLevel: 5 },
        { speciesId: 'sassolite', weight: 30, minLevel: 2, maxLevel: 5 },
        { speciesId: 'ecora', weight: 25, minLevel: 3, maxLevel: 6 },
        { speciesId: 'lucciolfo', weight: 15, minLevel: 3, maxLevel: 6 },
      ],
      anomaly: [
        { speciesId: 'bramuca', weight: 40, minLevel: 6, maxLevel: 9 },
        { speciesId: 'marevia', weight: 40, minLevel: 6, maxLevel: 9 },
        { speciesId: 'lucciolfo', weight: 20, minLevel: 7, maxLevel: 10 },
      ],
    },
    encounterRate: { tallGrass: 0.12, anomaly: 0.2 },
  };
}
